<!-- D&I BANNER SECTION -->
<div class="image_outer" [ngStyle]="{'background-image': 'url('+imageURL + ')'}">


</div>

<!-- DETAILS AND LATEST BPG NEWS SECTION -->

<div class="mapBorder">
  <div class="mapContainer ">
    <div class="bpgHeading">
      <ng-select placeholder="All BPG's" [items]="bpgList" name="bpgName" bindLabel="bpgName" class="custom"
        bindValue="bpgId" [(ngModel)]="selectedBpg" (change)="selectSite(selectedBpg)">
      </ng-select>
    </div>

    <div class="labelHeading">
      <span class="dataCount" *ngIf="totalSites!= null && totalSites!= undefined"> {{totalSites}} <span
          class="labelName">Sites </span></span>
      <span class="dataCount" *ngIf="totalChapters!= null && totalChapters!= undefined"> {{totalChapters}} <span
          class="labelName">Chapters</span> </span>
      <span class="dataCount" *ngIf="totalMembershipCount!= null && totalMembershipCount!= undefined">
        {{totalMembershipCount}} <span class="labelName">Memberships</span></span>
    </div>


    <div class="row">

      <!-- Code for displaying USA MAP -->
      <div class="col-md-4  map ">

        <div class="form-group">

        </div>

        <div #areaMapCanada></div>

      </div>

      <!-- Code for displaying Canada MAP -->
      <div class="col-md-4 mapMarginUSA">
        <div class="form-group">

        </div>
        <div #areaMapUSA></div>
      </div>

      <!-- Code for displaying Mexico MAP -->
      <div class="col-md-4 mapMarginMexico">
        <div class="form-group">

        </div>
        <div #areaMapMexico></div>
      </div>

    </div>




    <!-- REGIONAL ENGAGEMENT TEAM SECTION -->
    <div *ngIf="reTeamList != null && reTeamList != undefined && reTeamList.length > 0">
      <div class="row">

        <h3 class="col-md-12" id="engagementTeam">BUSINESS + COMMUNITY ENGAGEMENT TEAM</h3>
        <div class="reteam engagement_div" *ngFor="let reTeaminfo of reTeamList">
          <div>
            <img src={{reTeaminfo.userPic}} alt="" class="picture"></div>
          <div class="userdetails">
            <div class="username">{{reTeaminfo.userName}} </div>
            <div class="rolename" style="font-family: 'Montserrat-Regular',sans-serif;">{{reTeaminfo.roleName}}</div>
            <div class="rolename"><span class="fa fa-envelope" style="color:#b62027 ;">
                <a class="email" href="mailto:{{reTeaminfo.emailId}}">{{reTeaminfo.emailId}}</a></span></div>
            <div class="rolename"
              *ngIf="(reTeaminfo.siteName!= null && reTeaminfo.siteName!= '' && reTeaminfo.siteName!= undefined)">
              <span class="siteLabel"> Assigned Sites :</span>
              <span class="siteValue">{{reTeaminfo.siteName}}</span></div>

            <div class="rolename"
              *ngIf="(reTeaminfo.diPronounce!= null && reTeaminfo.diPronounce!= '' && reTeaminfo.diPronounce!= undefined)">
              <span class="siteLabel">Pronouns :</span>
              <span class="siteValue">{{reTeaminfo.diPronounce}}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    
    <!-- ADDITIONAL BPG RESOURCES & NAAC SECTION -->
    <div>
      <div class="row">
        <div class="col-md-12 additional_bpg_outerdiv" [ngClass]="{'hideDesc_2': !flag2}">

          <h3 class="additional_heading">ADDITIONAL BPG RESOURCES</h3>
          <div *ngFor="let resourceInfo of folderNameList,let i=index;">
            <div class="resourceTitle"><a class="resorce_underline"
                (click)="selectdiFolder(resourceInfo.folderId)">{{resourceInfo.Maxmin}} </a>{{resourceInfo.folderName}}
            </div>
            <span *ngIf="resourceInfo.showFolder">
              <span *ngFor="let file of fileList,let j=index;">
                <div class="filename"><a class="files" (click)="downloadAttachments(file.diResourceDocument,j,resourceInfo.folderName,file.diResourceTitle)"
                    downloadAttachments-btn id='downloadFiles{{j}}'>{{file.diResourceTitle}}</a></div>
              </span> </span>

          </div>
        </div>
        <!-- <div class="col-md-6 full_description_outerdiv bpg_news_outerdiv">
          <span class="news_heading">LATEST BPG NEWS</span>
          <span>&nbsp;</span> 
          <div class="news-scroller-header">
            <div class="news-scroll" id="newsId">
              <div *ngFor="let newsInfo of diBpgNewsList">
                <div>
                  <img src="{{newsInfo.diNewsName}}" class="news_image" alt="Angular Logo">

                </div>
                <div class="title_main_div side-left ">
                  <div class="news_title ">{{newsInfo.diNewsTitle}}</div>
                  <div class="news_create_time">{{newsInfo.modifiedDateTime | date:'MM-dd-yyyy'}}</div>
                </div>

                <div class="news_description_div side-left">
                  <p class="news_description" *ngIf="newsInfo.showFullWord">{{newsInfo.diNewsDesc}} </p>
                  <p class="news_description" *ngIf="!newsInfo.showFullWord">{{newsInfo.minWord}} </p>
                  <span class="viewmore" (click)=showFullDesc(newsInfo.diNewsId) *ngIf="!newsInfo.showFullWord"> View
                    More</span>
                  <span
                    *ngIf="(newsInfo.diNewsDesc==null || newsInfo.diNewsDesc==undefined || newsInfo.diNewsDesc=='')">
                    &nbsp;</span>
                </div>
                <div *ngIf="(newsInfo.diNewsLink== '' || newsInfo.diNewsLink==undefined || newsInfo.diNewsLink== null)">
                  &nbsp;</div>
                <div class="news_link_div side-left"
                  *ngIf="newsInfo.diNewsLink!= null && newsInfo.diNewsLink.substring(0,4) =='http'">
                  <a class="news_link" href="{{newsInfo.diNewsLink}}" target="_blank"
                    rel="noopener">{{newsInfo.diNewsLink.length > 35 ? newsInfo.diNewsLink.slice(0,35)+'...' : newsInfo.diNewsLink}}</a>
                </div>
                <div class="news_link_div side-left"
                  *ngIf="newsInfo.diNewsLink!= null  && newsInfo.diNewsLink.substring(0,4) !='http'">
                  <a class="news_link" href="http://{{newsInfo.diNewsLink}}"
                    target="_blank">{{newsInfo.diNewsLink.length > 35 ? newsInfo.diNewsLink.slice(0,35)+'...' : newsInfo.diNewsLink}}</a>
                </div>

                <hr>
              </div>
            </div>
          </div>
         
        </div> -->
      </div>

    
    </div>